import { startTransition, useState } from 'react';
import { useAtom } from 'jotai';

import { post } from '@rewardopl/utils/network';

import LikeButton from './like_button';

import { vendorProductQuery } from '../../store';

import type { Product, ProductWithDynamicPropertiesForUser } from '@rewardopl/types';

type ProductLikeButtonProps = {
  productId: Product['_id'];
};

export default function ProductLikeButton({ productId }: ProductLikeButtonProps) {
  const [product, setProduct] = useAtom(vendorProductQuery(productId));

  const { is_liked_by_current_user: isLiked } = product;

  const [optimisticIsLiked, setOptimisticIsLiked] = useState<boolean | undefined>(isLiked);

  const isLikedWithOptimisticIsLiked = optimisticIsLiked ?? isLiked;

  const action = `/api/products/${product._id}/${isLikedWithOptimisticIsLiked ? 'unlike' : 'like'}`;

  async function onClick(event: React.MouseEvent<HTMLButtonElement, MouseEvent>) {
    event.preventDefault();

    setOptimisticIsLiked(!isLikedWithOptimisticIsLiked);

    try {
      const response = (await post(action)) as ProductWithDynamicPropertiesForUser;

      startTransition(() => {
        setProduct(response);
      });
    } catch {}

    setOptimisticIsLiked(undefined);
  }

  return <LikeButton isLiked={isLikedWithOptimisticIsLiked} onClick={onClick} />;
}
